import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { SessionProvider, useSession } from './contexts';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import BanksPage from './pages/BanksPage';
import ConsentsPage from './pages/ConsentsPage';
import ConsentConfirmPage from './pages/ConsentConfirmPage';
import ConsentSuccessPage from './pages/ConsentSuccessPage';
import ConsentErrorPage from './pages/ConsentErrorPage';
import AccountsPage from './pages/AccountsPage';
import PaymentsPage from './pages/PaymentsPage';
import Layout from './components/layout/Layout';

function ProtectedRoute() {
  const { isAuthenticated, loading } = useSession();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center space-y-3">
          <svg
            className="animate-spin text-primary-600 mx-auto"
            style={{ width: '32px', height: '32px' }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          <p style={{ fontSize: '14px', color: '#6b7280' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function PublicRoute() {
  const { isAuthenticated, loading } = useSession();

  if (loading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <LoginPage />;
}

function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute />} />
          <Route path="/" element={<ProtectedRoute />}>
            <Route index element={<DashboardPage />} />
            <Route path="banks" element={<BanksPage />} />
            <Route path="accounts" element={<AccountsPage />} />
            <Route path="consent/confirm" element={<ConsentConfirmPage />} />
            <Route path="consent/success" element={<ConsentSuccessPage />} />
            <Route path="consent/error" element={<ConsentErrorPage />} />
            <Route path="consents" element={<ConsentsPage />} />
            <Route path="payments" element={<PaymentsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </SessionProvider>
  );
}

export default App;

